<h3 class="links-title" *ngIf="title">{{title}}</h3>

<div class="links">
  <a *ngFor="let link of links" [href]="link.link" class="link" target="_blank">{{link.text}}</a>
</div>
